import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'sst-pre-implentation-questionnaire';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Pre-implementation questionnaire',
};

const sstPreImplentationQuestionnaire = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { sstPreImplentationQuestionnaire };
